import { MatDialogRef } from '@angular/material';
import { Component } from '@angular/core';

@Component({
  selector: 'app-load-file',
  templateUrl: './app-load-file.component.html',
  styleUrls: ['./app-load-file.component.css']
})
export class AppLoadFileComponent {

  nameFile: string = "";
  evt: any = null;

  constructor(public _matDialogRef: MatDialogRef<AppLoadFileComponent>) {
  }

  close(): void {
    if(this.evt) {
      this._matDialogRef.close(this.evt);  
    }
  }

  getNameFile(evt: any): void {
    this.evt = evt;
    this.nameFile = evt.target.files[0].name;
  }
}